class PeSpSlider extends HTMLElement {
  connectedCallback() {
    this.scroller = this.querySelector('[data-pe-sp-scroller]');
    this.prev = this.querySelector('[data-pe-sp-prev]');
    this.next = this.querySelector('[data-pe-sp-next]');
    if (!this.scroller) return;

    this.onPrev = () => this.scrollByCards(-1);
    this.onNext = () => this.scrollByCards(1);
    if (this.prev) this.prev.addEventListener('click', this.onPrev);
    if (this.next) this.next.addEventListener('click', this.onNext);

    this.onScroll = () => this.updateButtons();
    this.scroller.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onScroll, { passive: true });

    // Démarrer au tout début : certains navigateurs appliquent un léger
    // décalage de scroll au chargement (snap / focus), ce qui activait à tort
    // la flèche précédente. On force le retour à 0 puis on met à jour.
    this.scroller.scrollLeft = 0;
    requestAnimationFrame(() => {
      this.scroller.scrollLeft = 0;
      this.updateButtons();
    });

    this.updateButtons();
  }

  disconnectedCallback() {
    if (this.prev) this.prev.removeEventListener('click', this.onPrev);
    if (this.next) this.next.removeEventListener('click', this.onNext);
    if (this.scroller) this.scroller.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onScroll);
  }

  cardStep() {
    const card = this.scroller.querySelector('.pe-sp__card');
    if (!card) return this.scroller.clientWidth * 0.8;
    const style = getComputedStyle(this.scroller.querySelector('.pe-sp__track'));
    const gap = parseFloat(style.columnGap || style.gap || '0') || 0;
    return card.getBoundingClientRect().width + gap;
  }

  scrollByCards(dir) {
    this.scroller.scrollBy({ left: dir * this.cardStep(), behavior: 'smooth' });
  }

  updateButtons() {
    const max = this.scroller.scrollWidth - this.scroller.clientWidth - 1;
    const x = this.scroller.scrollLeft;
    if (this.prev) this.prev.disabled = x <= 0;
    if (this.next) this.next.disabled = x >= max;
  }
}
if (!customElements.get('pe-sp-slider')) {
  customElements.define('pe-sp-slider', PeSpSlider);
}
